import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-60370980"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-container" }

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import * as echarts from 'echarts'
import { ResizeService } from '@/services/resize.service'
import { getAssignPieOption } from '@/utils/echarts-option/pie'
import { getChartPieMixedPalette } from '@/utils/chart-theme-colors'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'
import Card from '@/views/dashboard/_components/card/card.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import PieCenter from '@/views/dashboard/_components/echarts/pie-center.vue'
import { getPeripheralTypeLabel } from '../../usb-statistics/peripheral-type-i18n'

export interface ChartDataItem {
  name: string
  value: number
  /** 与概览接口一致，用于列表筛选 */
  peripheral_type?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'usb-device-type-distribution-chart',
  props: {
    data: { default: () => [
    { name: '', value: 10, peripheral_type: 1 },
    { name: '', value: 15, peripheral_type: 2 },
    { name: '', value: 5, peripheral_type: 0 }
  ] }
  },
  emits: ["sliceClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t, locale } = useI18n()
const injector = useReflectiveInjector([ResizeService])
const resizeService = injector.get(ResizeService)

const chartData = computed(() => props.data || [])

const totalCount = computed(() =>
  chartData.value.reduce((sum, item) => sum + item.value, 0)
)

const hasData = computed(() => totalCount.value > 0)

const colors = computed(() => getChartPieMixedPalette())

const chartRef = ref<HTMLElement>()
let chartInstance: echarts.EChartsType | null = null

function getChartData () {
  void locale.value
  return chartData.value.map((item, index) => ({
    value: item.value,
    name: getPeripheralTypeLabel(item.peripheral_type, t) || item.name,
    peripheral_type: item.peripheral_type,
    itemStyle: {
      color: colors.value[index % colors.value.length],
    },
  }))
}

function createChart () {
  if (!chartRef.value) return
  chartInstance = echarts.init(chartRef.value)
}

function getChartOption () {
  const option = {
    series: [{
      name: t('usbPolicy.usbDeviceTypeDist'),
      data: getChartData(),
    }],
  }

  return getAssignPieOption(option, { unit: t('usbPolicy.unitPiece') })
}

function renderChart () {
  if (!chartInstance) return
  chartInstance.setOption(getChartOption())
}

function handleChartClick (params: { data?: ChartDataItem }) {
  const d = params.data
  if (!d || typeof d.peripheral_type !== 'number') return
  emit('sliceClick', { peripheral_type: d.peripheral_type, name: d.name })
}

function initChart () {
  chartInstance?.dispose()
  createChart()
  renderChart()
  chartInstance?.on('click', handleChartClick)
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance && chartInstance.resize()
})

watch(() => chartData.value, () => {
  if (!hasData.value) return
  if (!chartInstance) {
    nextTick(initChart)
  } else {
    renderChart()
  }
}, { deep: true })

watch(locale, () => {
  if (!hasData.value || !chartInstance) return
  renderChart()
})

useEchartsThemeSync(() => {
  if (chartInstance && hasData.value) renderChart()
})

onMounted(() => {
  if (hasData.value) {
    setTimeout(() => initChart(), 100)
  }
})

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance && chartInstance.dispose()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: _ctx.$t('usbPolicy.usbDeviceTypeDist'),
    class: "usb-device-type-distribution-chart-wrap"
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "chart"
        }, null, 512),
        _createVNode(PieCenter, {
          title: _ctx.$t('usbPolicy.totalCount'),
          value: totalCount.value,
          unit: _ctx.$t('usbPolicy.unitPiece')
        }, null, 8, ["title", "value", "unit"])
      ], 512), [
        [_vShow, hasData.value]
      ]),
      _withDirectives(_createVNode(EmptyData, {
        height: "100%",
        "bg-color": "transparent"
      }, null, 512), [
        [_vShow, !hasData.value]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})